import axios from "@/plugins/axios";
import * as dshop from "./dshop";
import * as gshop from "./gshop";
import * as center from "./center";
import * as profile from "./profile";
import * as shop from "./shop";
import * as roulette from "./roulette";
import * as hunt from "./hunt";
import * as clover from "./clover";
import * as cash from "./cash";
import * as point from "./point";
import * as gifts from "./gifts";
import * as logout from "./logout";

export const me = {
    ...dshop,
    ...gshop,
    ...cash,
    ...center,
    ...profile,
    ...shop,
    ...roulette,
    ...hunt,
    ...clover,
    ...point,
    ...gifts,
    ...logout,
    
    withdraw(){
        return axios.put(`/api/v1/me/withdraw`).then(result => result.data);
    },
    certificate(data){
        return axios.put(`/api/v1/me/certificate`, data).then(result => result.data);
    }
}